import { useState,useEffect } from 'react'
import { TextField } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { post } from '../../utils/axios'
import { toast } from 'react-toastify'
import Button from '../../components/Button'

const Register = () => {

    const navigate = useNavigate()

    const [phone,setPhone] = useState('')
    const [isLoading,setIsLoading] = useState(false)
    const [nationalCode,setNationalCode] = useState('')

    useEffect(() => {
        if(phone && phone.length){
            if(phone.includes('۰'))
                setPhone(phone.replace(/۰/g,'0'))
            if(phone.includes('۱'))
                setPhone(phone.replace(/۱/g,'1'))
            if(phone.includes('۲'))
                setPhone(phone.replace(/۲/g,'2'))
            if(phone.includes('۳'))
                setPhone(phone.replace(/۳/g,'3'))
            if(phone.includes('۴'))
                setPhone(phone.replace(/۴/g,'4'))
            if(phone.includes('۵'))
                setPhone(phone.replace(/۵/g,'5'))
            if(phone.includes('۶'))
                setPhone(phone.replace(/۶/g,'6'))
            if(phone.includes('۷'))
                setPhone(phone.replace(/۷/g,'7'))
            if(phone.includes('۸'))
                setPhone(phone.replace(/۸/g,'8'))
            if(phone.includes('۹'))
                setPhone(phone.replace(/۹/g,'9'))
        }
    },[phone])

    useEffect(() => {
        if(nationalCode && nationalCode.length){
            if(nationalCode.includes('۰'))
                setNationalCode(nationalCode.replace(/۰/g,'0'))
            if(nationalCode.includes('۱'))
                setNationalCode(nationalCode.replace(/۱/g,'1'))
            if(nationalCode.includes('۲'))
                setNationalCode(nationalCode.replace(/۲/g,'2'))
            if(nationalCode.includes('۳'))
                setNationalCode(nationalCode.replace(/۳/g,'3'))
            if(nationalCode.includes('۴'))
                setNationalCode(nationalCode.replace(/۴/g,'4'))
            if(nationalCode.includes('۵'))
                setNationalCode(nationalCode.replace(/۵/g,'5'))
            if(nationalCode.includes('۶'))
                setNationalCode(nationalCode.replace(/۶/g,'6'))
            if(nationalCode.includes('۷'))
                setNationalCode(nationalCode.replace(/۷/g,'7'))
            if(nationalCode.includes('۸'))
                setNationalCode(nationalCode.replace(/۸/g,'8'))
            if(nationalCode.includes('۹'))
                setNationalCode(nationalCode.replace(/۹/g,'9'))
        }
    },[nationalCode])

    const register = async e => {
        setIsLoading(true)
        e.preventDefault()
        const postedData = {
            mobile: phone,
            nationalCode
        }
        const { data } = await post('User/RegisterUser',postedData)
        if(data.isSuccess){
            localStorage.setItem('username',nationalCode)
            localStorage.setItem('phone',phone)
            toast.success('کد اعتبارسنجی به شماره همراه شما ارسال شد')
            setTimeout(() => {
                navigate('/auth/verify')
            },300)
        }else
            toast.error(data.message)
        setIsLoading(false)
    }

    return (
        <form className="auth-container" onSubmit={e => register(e)}>
            <h2 className="auth-page-title">احراز هویت</h2>
            <TextField type="tel" className="ltr-input" sx={{mb: 2}} fullWidth={true} inputProps={{maxLength: 10}} label="کد ملی" variant="standard" value={nationalCode} onChange={e => setNationalCode(e.target.value)} />
            <TextField type="tel" className="ltr-input" sx={{mb: 2}} fullWidth={true} inputProps={{maxLength: 11}} label="شماره همراه" variant="standard" value={phone} onChange={e => setPhone(e.target.value)} />
            <Button isLoading={isLoading} fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!phone || !nationalCode} onClick={register}>احراز هویت</Button>
            <p className="auth-page-footer">حساب کاربری دارید؟ <Link to="/auth/login">وارد شوید</Link></p>
        </form>
    )
}

export default Register